import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RIFERIMENTI } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolRiferimentiState extends EntityState<IID_OL_RIFERIMENTI, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RIFERIMENTI })
@InterfaceDataStore(InterfaceName.RIFERIMENTI)
export class IIDolRiferimentiStore extends EntityStore<IIDolRiferimentiState> {
  constructor() {
    super([]);
  }
}
